import React from 'react'
import Card from '../../../../components/common/Card'
import DefaultTable from '../../../../components/tables/DefaultTable/DefaultTable'
import Badge from '../../../../components/ui/badge/Badge'

const Business = () => {
    const rows = [
        {
            id: 1,
            name: 'Subscrição anual do Zylker',
            situation: <Badge color='warning'>Negociação</Badge>,
            value: 'R$ 5.000,00',
            dateConclusion: '28/02/2025'
        },
        {
            id: 2,
            name: 'Nova negociação',
            situation: <Badge color='primary'>Meet</Badge>,
            value: '--',
            dateConclusion: '22/02/2025'
        }
    ]

    const columns = [
        {
            key: 'name',
            label: 'Nome'
        },
        {
            key: 'situation',
            label: 'Situação'
        },
        {
            key: 'value',
            label: 'Valor'
        },
        {
            key: 'dateConclusion',
            label: 'Data de conclusão'
        }
    ]

    const handleClick = (row: any) => {}

    return (
        <Card>
            <h4 className='font-bold mb-4'>Negócios</h4>
            <DefaultTable columns={columns} rows={rows} rowsPerPage={20} handleClick={handleClick} />
        </Card>
    )
}

export default Business
